import axios from 'axios';

const api = axios.create({
  baseURL: 'https://commerceplus.info/apps/appgestor/api',
  headers: {
    post: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  },
});

api.defaults.timeout = 120000;

api.interceptors.response.use(
  function (response) {
    if (
      response &&
      response.data &&
      response.data.code &&
      response.data.code === '401'
    ) {
      localStorage.removeItem('@commerceplus_auth:token');
    }
    return response;
  },
  function (error) {
    if (error.response.status === 401) {
      localStorage.removeItem('@commerceplus_auth:token');
    } else {
      return Promise.reject(error);
    }
  },
);

export default api;
